import { useUserStore } from '@/stores/user/userStore'
import type { IEvent } from '@/types'

/**
 * Utility pro zjištění, jestli je aktuální uživatel přihlášen k události.
 * Kontroluje všechny koše: attendants, homeAttendants, awayAttendants,
 * home/awayInDeposit, legacy inDeposit.
 */
export function useUserAttending() {
  const userStore = useUserStore()

  const isAttending = (event: IEvent): boolean => {
    const userId = userStore.getUserId
    if (!userId || !event) return false

    const eq = (x: any, id: string) => String(x?._id ?? x) === String(id)

    // Standardní attendants
    const attP = event.attendants?.players ?? []
    const attG = event.attendants?.goalies ?? []

    // Home / Away attendants
    const homeAttP = event.homeAttendants?.players ?? []
    const homeAttG = event.homeAttendants?.goalies ?? []
    const awayAttP = event.awayAttendants?.players ?? []
    const awayAttG = event.awayAttendants?.goalies ?? []

    // Home / Away deposit (nová struktura)
    const homeDepP = event.homeInDeposit?.players ?? []
    const homeDepG = event.homeInDeposit?.goalies ?? []
    const awayDepP = event.awayInDeposit?.players ?? []
    const awayDepG = event.awayInDeposit?.goalies ?? []

    // Legacy inDeposit — může být {players, goalies} NEBO prosté pole
    const legacyDepObjP = (event as any).inDeposit?.players ?? []
    const legacyDepObjG = (event as any).inDeposit?.goalies ?? []
    const legacyDepFlat = Array.isArray((event as any).inDeposit) ? (event as any).inDeposit : []

    const inAttendants =
      attP.some((x: any) => eq(x, userId)) ||
      attG.some((x: any) => eq(x, userId)) ||
      homeAttP.some((x: any) => eq(x, userId)) ||
      homeAttG.some((x: any) => eq(x, userId)) ||
      awayAttP.some((x: any) => eq(x, userId)) ||
      awayAttG.some((x: any) => eq(x, userId))

    const inDeposit =
      homeDepP.some((x: any) => eq(x, userId)) ||
      homeDepG.some((x: any) => eq(x, userId)) ||
      awayDepP.some((x: any) => eq(x, userId)) ||
      awayDepG.some((x: any) => eq(x, userId)) ||
      legacyDepObjP.some((x: any) => eq(x, userId)) ||
      legacyDepObjG.some((x: any) => eq(x, userId)) ||
      legacyDepFlat.some((x: any) => eq(x, userId))

    return inAttendants || inDeposit
  }

  return { isAttending }
}
